export class Department {
    id = null;
    departmentNumber = '';
    description = '';
}


